import React from 'react';
import { useInView } from '../hooks/useInView';
import { C, F } from '../constants';
import { motion } from 'framer-motion';

export const Eye = ({ children }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      fontFamily: F,
      fontSize: '12px',
      fontWeight: 700,
      letterSpacing: '0.2em',
      textTransform: 'uppercase',
      color: C.secondary,
      marginBottom: '16px'
    }}
  >
    <div style={{ width: '40px', height: '2px', background: C.secondary }} />
    {children}
    <div style={{ width: '40px', height: '2px', background: C.secondary }} />
  </div>
);

export const Sec = ({ children, dark = false, style = {}, id }) => {
  return (
    <section
      id={id}
      className="relative overflow-hidden"
      style={{
        background: dark ? '#FFFFFF' : C.black,
        color: dark ? C.black : C.white,
        padding: 'clamp(48px, 10vw, 96px) clamp(16px, 4vw, 24px)',
        ...style
      }}
    >
      {children}
    </section>
  );
};

export const SH = ({ eyebrow, title, accent, subtitle, center = false }) => {
  const { ref, v } = useInView();

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={v ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6 }}
      style={{
        maxWidth: center ? '800px' : '100%',
        margin: center ? '0 auto 64px' : '0 0 64px',
        textAlign: center ? 'center' : 'left'
      }}
    >
      {eyebrow && <Eye>{eyebrow}</Eye>}
      <h2
        style={{
          fontFamily: F,
          fontSize: 'clamp(32px, 5vw, 56px)',
          fontWeight: 700,
          lineHeight: 1.2,
          marginBottom: '16px'
        }}
      >
        {title}
        {accent && (
          <span style={{ background: C.grad, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            {' '}{accent}
          </span>
        )}
      </h2>
      {subtitle && (
        <p
          className="font-[Manrope]"
          style={{
            fontSize: '18px',
            lineHeight: 1.6,
            opacity: 0.8,
            maxWidth: '700px',
            margin: center ? '0 auto' : '0'
          }}
        >
          {subtitle}
        </p>
      )}
    </motion.div>
  );
};